import React, { FC } from 'react';

import { MobileHeader } from 'src/components/templates/CatalogPage/MobileCatalogPage/MobileHeader';
import { MobileSlider } from 'src/components/templates/CatalogPage/MobileCatalogPage/MobileSlider';
import { ProductsDrawer } from 'src/components/organisms/ProductsDrawer';

export const MobileCatalogPage: FC = () => {
  return (
    <>
      <MobileHeader />
      <MobileSlider />
      <ProductsDrawer />
    </>
  );
};
